import * as React from 'react';

import { Kbd as RadixKbd } from '@radix-ui/themes';
import type { RadixKbdProps } from '@/types/radix-ui';
import clsx from 'clsx';

export type KbdSize = 'small' | 'medium' | 'large';
export type KbdColor =
  | 'default'
  | 'primary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';
export type KbdVariant = 'outline' | 'surface' | 'classic' | 'ghost';

export interface KbdProps extends Omit<RadixKbdProps, 'size'> {
  size?: KbdSize;
  color?: KbdColor;
  variant?: KbdVariant;
  hotkey?: string;
}

const sizeMapping: Record<KbdSize, RadixKbdProps['size']> = {
  small: '1',
  medium: '3',
  large: '5',
};

/**
 * Kbd — simple wrapper for Radix Themes Kbd. In the future, this component will be extended and adapted for the project design system.
 */
export const Kbd: React.FC<KbdProps> = ({
  size = 'medium',
  color = 'default',
  variant = 'surface',
  hotkey,
  className,
  ...rest
}) => {
  return (
    <RadixKbd
      size={sizeMapping[size]}
      className={clsx(
        'kbd',
        `kbd--size-${size}`,
        `kbd--color-${color}`,
        `kbd--variant-${variant}`,
        className
      )}
      {...rest}
    >
      {hotkey || rest.children}
    </RadixKbd>
  );
};
